import { UPDATE_ADMIN_APP_DATA, ADD_RULE_SET_TO_LIST, DELETE_RULE_SET_IN_LIST, UPDATE_WIDTH_COLUMNS_RULE_SET } from './appData.actions';

/** @type {AdminAppData.IAppData} */
const initialState = {
    //For Rule set
    ruleSets: [],
    dataviews: [], //used in Configuration Set & Archive
    hyperfinds: [], //used in Configuration Set & Archive
    customDateFormat: [],
    customDataFields: [],
    isAdminRuleSetAppDataLoaded: false,
    notificationCustomTags: {},
    paycodeList: [], //used in Configuration Set & Archive
    symbolicPeriods: [],

    //For Configuration Set & Archive
    settingList: [],
    segmentTagsList: [],
    scheduleTagsList: [],
    breRuleSetList: [],
    workRuleList: [],
    awardingRulesList: [],
    genericNotificationList: [],
    timePeriodRatioOptions: [],
    isConfigurationSetAppDataLoaded: false,
    breakRuleList: [],

    ruleSetColumnsWidths:{}
};

/**
 * @param {AdminAppData.IAppData} state
 * @param {EmploymentBillboard.IAction} action
 * */
export default function adminAppDataReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_ADMIN_APP_DATA:
            return {
                ...state,
                ...payload,
            };
        case ADD_RULE_SET_TO_LIST:
            return {
                ...state,
                ruleSets: [
                    ...state.ruleSets,
                    payload,
                ],
            };
        case DELETE_RULE_SET_IN_LIST: {
            const { ruleSetId } = payload;
            const indexToDelete = state.ruleSets.findIndex((x) => x.ruleSetId === ruleSetId);
            state.ruleSets.splice(indexToDelete, 1);
            return {
                ...state,
                ruleSets: [
                    ...state.ruleSets,
                ],
            };
        }
        case UPDATE_WIDTH_COLUMNS_RULE_SET:{
            return {
                ...state,
                ruleSetColumnsWidths: {
                  ...state.ruleSetColumnsWidths,
                  [action.payload.key]: action.payload.width
                }
              };
        }
        default:
            return state;
    }
}

export const setColumnWidth = (key, width) => ({
    type: UPDATE_WIDTH_COLUMNS_RULE_SET,
    payload: { key, width }
  });